import { render, staticRenderFns } from "./DatasetStorage.vue?vue&type=template&id=4d823fb4"
import script from "./DatasetStorage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetStorage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports